module.exports = __webpack_public_path__ + "img/map-4.33a1a5c5.svg";